export const RESTART_ON_REMOUNT = "@@saga-injector/restart-on-remount";
export const DAEMON = "@@saga-injector/daemon";
export const ONCE_TILL_UNMOUNT = "@@saga-injector/once-till-unmount";
export const ACCESSIBILITY_LINK =
  "https://www.meitavdash.co.il/articles/accessibility-updated-6-12-2020/";

// reCAPTCHA Enterprise
export const RECAPTCHA_DEV = "6LftGg8cAAAAANxmGsZ_41oEywoDLooNG49A8n0F";
export const RECAPTCHA_QA = "6LeYdA0cAAAAAGEb6m2zhhzmP8Krahd2-5fGzQyL";
export const RECAPTCHA_PROD = "6LdDvwwcAAAAAKfQNCTSNymCQ8Kzx3AL49aLiLLe";

export const RECAPTCHA_MAP = {
  "development": RECAPTCHA_DEV,
  "qa": RECAPTCHA_QA,
  "production": RECAPTCHA_PROD
};

export const RECAPTCHA_CURRENT_ENV = RECAPTCHA_MAP[import.meta.env.VITE_REACT_APP_ENVIRONMENT];

///console.log('RECAPTCHA_CURRENT_ENV: ', RECAPTCHA_CURRENT_ENV);